import Vue from 'vue'

const getters = {
    listAll: state => {
        return state.privilege_list
    },
    getSelectedRole: state => {
        if(state.selected_role){
            return state.selected_role
        } 
    }
}
export default getters


//////////////////
// WEBPACK FOOTER
// ./state/privilege/privilege.getters.js
// module id = null
// module chunks = 